<template>
  <div class="toolbar">
    <div class="content">
      <div class="top">
        <button class="board-settings" @click="openSettings">Settings</button>
      </div>
      <div class="item text-object fade-in" @click="addTextObject">
        <div class="item-grab-bar"></div>
        <div class="item-content">
          <div>text...</div>
        </div>
      </div>
      <div class="item text-object fade-in" @click="addGifObject">
        <div class="item-grab-bar"></div>
        <div class="item-content">
          <div>GIF</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  methods: {
    addTextObject() {
      this.$parent.createObject({
        type: 'text',
        text: '',
        x: this.getCenter(-125, -125).x,
        y: this.getCenter(-125, -125).y,
        width: 250,
        height: 250,
        backgroundColour: '#d2d2d2',
        textColour: 'black',
        zIndex: 1
      });
    },
    addGifObject() {
      this.$parent.createObject({
        type: 'gif',
        text: '',
        x: this.getCenter(-125, -125).x,
        y: this.getCenter(-125, -125).y,
        width: 250,
        height: 250,
        backgroundColour: '#d2d2d2',
        textColour: 'black',
        zIndex: 1
      });
    },
    openSettings() {
      this.$parent.showBoardSettings = true;
    },
    getCenter(xOffset = 0, yOffset = 0) {
      return {
        x: 0 - this.$parent.anchor.x + (this.$parent.width / 2) + xOffset,
        y: 0 - this.$parent.anchor.y + (this.$parent.width / 2) + yOffset
      }
    }
  }
}
</script>

<style scoped>

.board-settings {
  margin: 10px 0 10px 0;
}

.toolbar {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;

  width: 100px;

  background-color: rgb(204, 204, 204);

  transform: translate(70%);

  transition: 300ms;

  z-index: 2;

  opacity: .5;
}

.toolbar > .content {
  display: none;
}

.toolbar:hover {
  transform: translate(0);

  transition: 300ms;
  opacity: 1;
}

.toolbar:hover > .content {
  display:initial;
}

.content {

  position: absolute;
  top: 0;
  left: 5px;
  width: 90px;
  height: 100%;

  animation: fadeIn 200ms 1;

  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.item {
  width: 90px;
  height: 90px;

  background-color: rgb(204, 204, 204);
  border-radius: 4px;

  cursor: pointer;

  position: relative;
  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.44);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.44);

  margin: 5px 0;

  transition: 300ms;
}

.item:hover {
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,1);
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,1);
}

.item-content {
  padding: 5px 3px 3px 3px;
  font-size: 13px;
}

.text-object > .item-content {
  padding: 10px 0 0 5px;
  font-size: 10px;
}

.item-grab-bar {
  position: absolute;
  background-color: rgb(99, 99, 99);
  top: 3px;
  left: 3px;
  right: 3px;
  height: 5px;
}

.top {
  display: flex;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue